import { appVersion } from "js/appVersion";
import log from "js/core/logger";

class MigrationsHelper {
    static migrate(instance, lowerBoundInclusiveVersion, upperBoundInclusiveVersion) {
        if (!(lowerBoundInclusiveVersion && lowerBoundInclusiveVersion >= 4 &&
            upperBoundInclusiveVersion && upperBoundInclusiveVersion <= appVersion &&
            lowerBoundInclusiveVersion <= upperBoundInclusiveVersion)) {
            log.warn("Invalid migration bounds");
            return;
        }

        const className = instance.type || instance.constructor.name;
        log.info(log.MIGRATION)(`${className} migrating data from version ${lowerBoundInclusiveVersion} to ${upperBoundInclusiveVersion}`);

        for (let i = lowerBoundInclusiveVersion + 1; i <= upperBoundInclusiveVersion; i++) {
            const migrateMethod = instance[`_migrate_${i}`];
            if (migrateMethod) migrateMethod.call(instance);
        }
    }
}

export { MigrationsHelper };

